<template>
  <AppLayout>
    <template #middle>
      <InnerContent>
        <GroupsContent />
      </InnerContent>
    </template>
    <template #outside>
      <GroupStructureModal />
    </template>
  </AppLayout>
</template>

<script setup lang="ts">
import AppLayout from '@/(routes)/(protected)/(app)/layout.vue'
import GroupStructureModal from '@/features/admin/groups/components/group-structure-modal/group-structure-modal.vue'
import InnerContent from '@/features/ui/components/inner-content/inner-content.vue'
import GroupsContent from '@/features/ui/pages/admin/groups/groups-content/groups-content.vue'
</script>
